module.exports = __webpack_public_path__ + "static/media/813FGHSdITL._AC_SL1500_.2f300758.jpg";